import { render } from "./SignatureNote.vue?vue&type=template&id=ccc78e54"
import script from "./SignatureNote.vue?vue&type=script&lang=js"
export * from "./SignatureNote.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/gradbeni-dnevnik/gradbeni-dnevnik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__